import { UrlLoader } from '@graphql-tools/url-loader';
import { buildClientSchema, introspectionFromSchema, buildSchema } from 'graphql';
import { introspectSchema } from '@graphql-tools/wrap';
import { getInterpolatedHeadersFactory, getHeadersObject, loadFromModuleExportExpression, getInterpolatedStringFactory, getCachedFetch, } from '@graphql-mesh/utils';
export default class GraphQLHandler {
    constructor({ config, baseDir, cache, introspectionCache = {}, }) {
        this.config = config;
        this.baseDir = baseDir;
        this.cache = cache;
        this.introspectionCache = introspectionCache;
    }
    async getMeshSource() {
        const { endpoint, schemaHeaders: configHeaders, introspection } = this.config;
        const customFetch = getCachedFetch(this.cache);
        if (endpoint.endsWith('.js') || endpoint.endsWith('.ts')) {
            const schema = await loadFromModuleExportExpression(endpoint, { cwd: this.baseDir });
            return {
                schema,
            };
        }
        else if (endpoint.endsWith('.graphql')) {
            const rawSDL = await loadFromModuleExportExpression(endpoint, { cwd: this.baseDir });
            const schema = buildSchema(rawSDL);
            return {
                schema,
            };
        }
        const urlLoader = new UrlLoader();
        const getExecutorAndSubscriberForParams = (params, headersFactory, endpointFactory) => {
            const resolverData = {
                root: {},
                args: params.variables,
                context: params.context,
            };
            const headers = getHeadersObject(headersFactory(resolverData));
            const endpoint = endpointFactory(resolverData);
            return urlLoader.getExecutorAndSubscriberAsync(endpoint, {
                customFetch,
                ...this.config,
                headers,
            });
        };
        let schemaHeaders = typeof configHeaders === 'string'
            ? await loadFromModuleExportExpression(configHeaders, { cwd: this.baseDir })
            : configHeaders;
        if (typeof schemaHeaders === 'function') {
            schemaHeaders = schemaHeaders();
        }
        if (schemaHeaders && 'then' in schemaHeaders) {
            schemaHeaders = await schemaHeaders;
        }
        const schemaHeadersFactory = getInterpolatedHeadersFactory(schemaHeaders || {});
        if (!this.introspectionCache.introspection) {
            const introspectionExecutor = async (params) => {
                const { executor } = await getExecutorAndSubscriberForParams(params, schemaHeadersFactory, () => endpoint);
                return executor(params);
            };
            if (introspection) {
                const result = await urlLoader.handleSDLAsync(introspection, {
                    customFetch,
                    ...this.config,
                    headers: schemaHeaders,
                });
                this.introspectionCache.introspection = introspectionFromSchema(result.schema);
            }
            else {
                this.introspectionCache.introspection = introspectionFromSchema(await introspectSchema(introspectionExecutor));
            }
        }
        const nonExecutableSchema = buildClientSchema(this.introspectionCache.introspection);
        const operationHeadersFactory = getInterpolatedHeadersFactory(this.config.operationHeaders);
        const endpointFactory = getInterpolatedStringFactory(endpoint);
        return {
            schema: nonExecutableSchema,
            executor: async (params) => {
                const { executor } = await getExecutorAndSubscriberForParams(params, operationHeadersFactory, endpointFactory);
                return executor(params);
            },
            subscriber: async (params) => {
                const { subscriber } = await getExecutorAndSubscriberForParams(params, operationHeadersFactory, endpointFactory);
                return subscriber(params);
            },
            batch: 'batch' in this.config ? this.config.batch : true,
        };
    }
}
//# sourceMappingURL=index.js.map